import { cn } from '@dc-shared-web/lib'
import { FC, ReactNode } from 'react'

export type PageHeaderProps = {
  topSlot?: ReactNode
  headerSlot: ReactNode
  actionsSlot?: ReactNode
  bottomSlot?: ReactNode
}

export const PageHeader: FC<PageHeaderProps> = ({
  topSlot,
  headerSlot,
  actionsSlot,
  bottomSlot,
}) => {
  return (
    <div className='tw-grid tw-gap-2'>
      {topSlot && <div>{topSlot}</div>}
      <div
        className={cn(
          'tw-grid tw-items-center',
          /* when do have the action slot, we make the header slot to take as much space as possible (that's what 1fr means). The right side, the actions slot, will take automatic space based on its content. */
          actionsSlot && 'tw-grid-cols-[1fr_auto] tw-gap-2'
        )}
      >
        <div>{headerSlot}</div>
        {actionsSlot && <div>{actionsSlot}</div>}
      </div>
      {bottomSlot && <div>{bottomSlot}</div>}
    </div>
  )
}
